// src/store/modules/authController.js
import axios from '@/api/axios'
import { MAIN_API } from '@/api/apiUrl'

export default {
    namespaced: true,
    state: {
        token: localStorage.getItem('token') || null,
        role: localStorage.getItem('role') || null
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token
            localStorage.setItem('token', token)
        },
        SET_ROLE(state, role) {
            state.role = role
            localStorage.setItem('role', role)
        },
        LOGOUT(state) {
            state.token = null
            state.role = null
            localStorage.removeItem('token')
            localStorage.removeItem('role')
        }
    },
    actions: {
        async login({ commit }, credentials) {
            const response = await axios.post(`${MAIN_API}/api/auth/login`, credentials, {
                headers: { 'Content-Type': 'application/json' }
            })
            commit('SET_TOKEN', response.data.token)
            commit('SET_ROLE', response.data.role)
            return response.data
        },
        logout({ commit }) {
            commit('LOGOUT')
        },
        async getAccountInfo() {
            const response = await axios.get(`${MAIN_API}/api/account`, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async updatePassword(_, data) {
            const response = await axios.put(`${MAIN_API}/api/account/password`, data, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
    },
    getters: {
        isAuthenticated: state => !!state.token,
        userRole: state => state.role,
        isRolePartner: state => state.role === 'ROLE_PARTNER',
        isRoleAdmin: state => state.role === 'ROLE_ADMIN',
    }
}
